// extracted by mini-css-extract-plugin
export default {"ldsDualRing":"LoadingSpinner_ldsDualRing__TSi++","primary":"LoadingSpinner_primary__gccBy","secondary":"LoadingSpinner_secondary__8g3jG","white":"LoadingSpinner_white__cXaUi"};